import { motion } from "framer-motion";

const EASE = [0.16, 1, 0.3, 1];

export const Reveal = ({ children, delay = 0, y = 30, className = "", as = "div" }) => {
  const Comp = motion[as] || motion.div;
  return (
    <Comp
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-70px" }}
      transition={{ duration: 0.9, delay, ease: EASE }}
      className={className}
    >
      {children}
    </Comp>
  );
};

export const ChapterLabel = ({ index, title, light = false }) => (
  <Reveal className={`flex items-center gap-4 label-caps ${light ? "text-ivory/60" : "text-charcoal/50"}`}>
    <span className="text-gold">{index}</span>
    <span className={`h-px w-10 ${light ? "bg-ivory/30" : "bg-charcoal/20"}`} />
    <span>{title}</span>
  </Reveal>
);

export { EASE };
